import { Link } from 'react-router-dom';

const SUBMIT_ADDR = 'https://readdy.ai/api/form/d933d2c41f1vs39a6btg';

export default function Footer() {
  const handleSubscribe = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypot = formData.get('website_alt') as string;
    if (honeypot && honeypot.trim()) {
      return;
    }
    const email = formData.get('email') as string;
    if (!email || !email.includes('@')) {
      return;
    }
    const payload = new URLSearchParams();
    payload.append('email', email);
    try {
      const res = await fetch(SUBMIT_ADDR, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: payload.toString(),
      });
      const text = await res.text();
      let parsed;
      try { parsed = JSON.parse(text); } catch { /* noop */ }
      const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || text;
      if (res.ok && parsed?.code === 'OK') {
        alert('订阅成功！感谢您的关注');
        form.reset();
      } else {
        alert(`订阅失败：${serverMsg}`);
      }
    } catch {
      alert('订阅失败，请稍后重试');
    }
  };

  return (
    <footer className="bg-foreground-900 text-background-200 mt-16">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-md bg-primary-500 flex items-center justify-center">
                <span className="text-background-50 font-bold text-xs">51</span>
              </div>
              <span className="font-bold text-lg text-background-50">黑料网</span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed">
              全网爆料第一入口，实时更新网红主播塌房内幕与娱乐八卦，24小时不停更。
            </p>
          </div>

          <div>
            <h4 className="text-background-50 font-semibold text-sm mb-4">快速导航</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-sm text-background-400 hover:text-background-200 transition-colors">首页</Link></li>
              <li><Link to="/category/meiri-chigua" className="text-sm text-background-400 hover:text-background-200 transition-colors">每日吃瓜</Link></li>
              <li><Link to="/category/dujia-mengliao" className="text-sm text-background-400 hover:text-background-200 transition-colors">独家猛料</Link></li>
              <li><Link to="/category/wanghong-tafang" className="text-sm text-background-400 hover:text-background-200 transition-colors">网红塌房</Link></li>
              <li><Link to="/about" className="text-sm text-background-400 hover:text-background-200 transition-colors">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-background-50 font-semibold text-sm mb-4">关注我们</h4>
            <ul className="space-y-2">
              <li>
                <a href="http://lalaxjk.cn/" rel="nofollow" className="text-sm text-background-400 hover:text-background-200 transition-colors flex items-center gap-2">
                  <span className="w-5 h-5 flex items-center justify-center"><i className="ri-weibo-line" /></span>
                  新浪微博
                </a>
              </li>
              <li>
                <a href="http://lalaxjk.cn/51heiliao" target="_blank" rel="noopener noreferrer nofollow" className="text-sm text-background-400 hover:text-background-200 transition-colors flex items-center gap-2">
                  <span className="w-5 h-5 flex items-center justify-center"><i className="ri-twitter-x-line" /></span>
                  Twitter
                </a>
              </li>
              <li>
                <a href="http://lalaxjk.cn/heiliao51" target="_blank" rel="noopener noreferrer nofollow" className="text-sm text-background-400 hover:text-background-200 transition-colors flex items-center gap-2">
                  <span className="w-5 h-5 flex items-center justify-center"><i className="ri-telegram-line" /></span>
                  Telegram
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-background-50 font-semibold text-sm mb-4">订阅爆料</h4>
            <p className="text-sm text-background-400 mb-3">第一时间获取最新爆料资讯</p>
            <form onSubmit={handleSubscribe} data-readdy-form="d933d2c41f1vs39a6btg" className="flex gap-2">
              <input type="text" name="website_alt" className="hp-field" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
              <input
                type="email"
                name="email"
                placeholder="输入邮箱地址"
                className="flex-1 min-w-0 px-3 py-2 bg-foreground-800 border border-foreground-700 rounded-md text-sm text-background-50 placeholder:text-background-500 focus:outline-none focus:border-primary-400"
                required
              />
              <button
                type="submit"
                className="w-10 h-10 flex-shrink-0 bg-primary-500 hover:bg-primary-600 rounded-md flex items-center justify-center text-background-50 transition-colors"
                aria-label="订阅"
              >
                <i className="ri-arrow-right-line" />
              </button>
            </form>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            2026 51黑料网 版权所有 | 本站内容仅供娱乐参考
          </p>
          <div className="flex items-center gap-4">
            <Link to="/about" className="text-xs text-background-500 hover:text-background-300 transition-colors">关于我们</Link>
            <Link to="/about" className="text-xs text-background-500 hover:text-background-300 transition-colors">免责声明</Link>
            <Link to="/about" className="text-xs text-background-500 hover:text-background-300 transition-colors">联系方式</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
